import { Feather, Ionicons, Octicons, Zocial } from '@expo/vector-icons';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import * as React from 'react';

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        SplashScreen.preventAutoHideAsync();

        // Load fonts
        await Font.loadAsync({
          ...Ionicons.font,
          ...Zocial.font,
          ...Octicons.font,
          ...Feather.font,
          // Font Weight 600
          'Poppins-SemiBold': require('../../assets/fonts/Poppins-SemiBold.ttf'),
          // Font Weight 400
          'Poppins-Regular': require('../../assets/fonts/Poppins-Regular.ttf'),
          // Font Weight 700
          'DMSans-Bold': require('../../assets/fonts/DMSans-Bold.ttf'),
          // Font Weight 500
          'DMSans-Medium': require('../../assets/fonts/DMSans-Medium.ttf'),
          // Font Weight 400
          'DMSans-Regular': require('../../assets/fonts/DMSans-Regular.ttf'),
          // Font Weight 400
          'WorkSans-Regular': require('../../assets/fonts/WorkSans-Regular.ttf'),
          // Font Weight 500
          'WorkSans-Medium': require('../../assets/fonts/WorkSans-Medium.ttf'),
          // Font Weight 600
          'WorkSans-SemiBold': require('../../assets/fonts/WorkSans-SemiBold.ttf')
        });
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
